/**
 * ClassificationCard Component
 *
 * Form card for selecting the classification of an asset or liability.
 *
 * Props:
 *   - classification: Current classification value
 *   - isAsset: Boolean indicating if this is an asset
 *   - isLiability: Boolean indicating if this is a liability
 *   - validationError: Error element to display
 *   - onFieldChange: Function(field, value) to update a field
 */

import React from 'react';
import { ASSET_CLASSES, LIABILITY_CLASSES } from 'utilities/global.variables';

const ClassificationButtons = ({ classes, classification, onFieldChange }) => (
  <div className="button-group flex regular margin-top-large" role="group">
    {classes.map((cls) => (
      <React.Fragment key={cls}>
        <input
          type="radio"
          name="classification"
          id={cls}
          checked={classification === cls}
          onChange={() => onFieldChange('classification', cls)}
        />
        <label htmlFor={cls}>{cls}</label>
      </React.Fragment>
    ))}
  </div>
);

const ClassificationCard = ({ classification, isAsset, isLiability, validationError, onFieldChange }) => {
  return (
    <div className="card">

<div className="flex row medium-gap center space">
        <p className="regular">Class</p>  {validationError}
      </div>

      {isAsset && <ClassificationButtons classes={ASSET_CLASSES} classification={classification} onFieldChange={onFieldChange} />}
      {isLiability && <ClassificationButtons classes={LIABILITY_CLASSES} classification={classification} onFieldChange={onFieldChange} />}
    </div>
  );
};

export default ClassificationCard;
